import { Injectable } from '@angular/core';
import { Statistics } from 'app/trello/models/board-summary';
import { AttachmentChartData } from 'app/trello/models/charts';
import { StatisticsAggregator } from 'app/trello/utility/statistics-aggregator';
import { StructureTransformer } from 'app/trello/utility/structure-transformer';

@Injectable({
  providedIn: 'root'
})
export class AttachmentChartDataAggregator {

  constructor(
    private readonly statisticsAggregator: StatisticsAggregator,
    private readonly statisticsTransformer: StructureTransformer,
  ) {
  }

  public aggregate(
    stats: Statistics,
    aggregationLevel: 'day' | 'week' | 'month' = 'day'
  ): AttachmentChartData {

    const totalAttachmentsData =
      this.statisticsAggregator.aggregateCountDistinct(
        stats.attachment.total.day || {},
        aggregationLevel,
      );

    const attachmentsAddedData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.attachment.added) || {},
        aggregationLevel,
      );

    return {
      totalAttachments: totalAttachmentsData,
      added: attachmentsAddedData,
    };
  }

}
